import $ from 'jquery';
import _ from 'underscore';

import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { showPausedCampaignNotifications } from '@bingads-webui-campaign/import-shared-utils';
import { columnChooserPlugin } from '@bingads-webui-campaign/projection-grid-column-chooser';
import { editablePlugin } from '@bingads-webui-campaign/projection-grid-editable';
import { inlineErrorPlugin } from '@bingads-webui/projection-grid-inline-error';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { assistedSelectionPlugin } from '@bingads-webui/projection-grid-assisted-selection';
import { perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { settingsBulkEdit } from './settings-bulk-edit';

export function getPlugins({
  columnConfig,
  perfMarker,
  getCampaignTypeGlobalFilter,
  instrumentation,
}) {
  const columnChooserConfig = columnConfig.getColumnChooserConfig(/* isForVNext */ true);
  const { i18n } = TargetingSettingsContext;

  columnChooserConfig.customToolbarIcon = 'ba-TripleColumnSolid';

  let pausedCampaignImportNotificationActivity;
  if (instrumentation) {
    pausedCampaignImportNotificationActivity = instrumentation.createScenarioAndActivity({
      scenarioName: 'PausedCampaignImportNotification',
      activityName: 'SettingsGridBulkEdit',
    }).activity;
  }

  return _.compact([{
    // For accurate grid init latency, PerfMarkerPlugin should be the first plugin to load.
    plugin: perfMarkerPlugin,
    config: {
      marker: perfMarker,
      appConfig: TargetingSettingsContext.config,
    },
  }, {
    plugin: paginationPlugin,
    config: {
      pageSize: 20,
      availablePageSizes: [20, 50, 100, 200],
      enableRandomPage: false,
      pageNumberLabelText: '',
      pageSizeText: i18n.getString('Grid_ShowRows'),
      totalPageCountText: i18n.getString('Grid_PageOf'),
    },
  }, !TargetingSettingsContext.config.get('CurrentAccountInActive') &&
      !TargetingSettingsContext.pageContext.Permissions.IsReadOnlyUser && {
    plugin: editablePlugin,
    config: { i18n },
  }, {
    plugin: uiBlockerPlugin,
    config: { el: $('.all-settings-page') },
  }, {
    plugin: columnChooserPlugin,
    config: columnChooserConfig,
  }, {
    plugin: inlineErrorPlugin({
      errorIconClasses: ['grid-error'],
    }),
  }, {
    plugin: settingsBulkEdit({
      status: TargetingSettingsContext.campaignStatus,
      ChangeStatusView: TargetingSettingsContext.ChangeStatusView,
      ChangeStatusModel: TargetingSettingsContext.ChangeStatusModel,
      ChangeUrlOptionsView: TargetingSettingsContext.ChangeUrlOptionsView,
      ChangeUrlOptionsModel: TargetingSettingsContext.ChangeUrlOptionsModel,
      ChangeRsaAutoAssetsView: TargetingSettingsContext.ChangeRsaAutoAssetsView,
      ChangeRsaAutoAssetsModel: TargetingSettingsContext.ChangeRsaAutoAssetsModel,
      getCampaignTypeGlobalFilter,
      i18n: TargetingSettingsContext.i18n,
      config: TargetingSettingsContext.config,
      importNotificationCallback: ({ campaignItemList, updateStatus }) => showPausedCampaignNotifications({ campaignItemList, updateStatus, activity: pausedCampaignImportNotificationActivity }), // show paused campaign notifications based on specific conditions
    }),
  }, {
    plugin: assistedSelectionPlugin,
  }, {
    plugin: a11yPlugin,
    config: { i18n: TargetingSettingsContext.i18n },
  }]);
}
